import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { ModalServiceContext, RicosContext } from './../../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../../../ricos-types';
import { LINK_MODAL_ID } from './../../../../_shared/link-modal/constants';
import { LinkIcon, ToggleButton } from './../../../../toolbars-ui';

type Props = {
  toolbarItem: IToolbarItem;
  dataHook?: string;
};

export const LinkButton: FC<Props> = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const isModalOpen = useModalState(getIsModalOpen(LINK_MODAL_ID));

  const [referenceElement, setReferenceElement] = useState();

  const onClick = () => {
    toolbarItem.commands.click({ referenceElement, modalService });
  };

  return (
    <ToggleButton
      active={isModalOpen || toolbarItem.attributes.active}
      Icon={LinkIcon}
      tooltip={t(toolbarItem.presentation?.tooltip)}
      onClick={onClick}
      setRef={setReferenceElement}
      dataHook={dataHook}
    />
  );
};
